import React from "react";
import { DomParser } from "../utils/dom-parser";
import { renderDate } from "../utils/text-display";
import { WidgetBox, Link, Empty } from "../components";
import classNames from "classnames";

const mockData = Array(3)
    .fill(0)
    .map(() => ({
        title: "Your upcoming session item",
        location: "Location",
        time: new Date("2020-08-31")
    }));

const YourUpcomingSessions = ({ title = "Your upcoming sessions" }) => {
    const listClasses = classNames("v-list", {
        "v-list--overflow": mockData.length > 3
    });

    // const externalLinkContainerClasses = classNames("external-link-container", {
    //     "external-link-container--overflow": mockData.length > 3
    // });

    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "div[data-tag='pnlUpcomingSessions'] > table"
        );

        const [, , mainTable] = domParser.columns || [];

        if (!mainTable) {
            return [];
        }

        return [];

        // const tds = mainTable.querySelectorAll("tbody > tr > td");
        // return chunk(tds, 2).map(row => {
        //     const [td1, td2] = row;
        //     console.log("HELLO", td1, td2);
        // });
    };

    const data = parseDataFromDOM();

    let titleLink = null;
    let titleLinkEl = document.querySelector(
        "div[data-tag='pnlUpcomingSessions'] a.titleLink"
    );

    if (titleLinkEl) {
        titleLink = titleLinkEl.getAttribute("href");
    }

    return (
        <WidgetBox title={title} icon="bell" noPadding titleLink={titleLink}>
            <div className={listClasses}>
                <div style={{ margin: "0px 45px" }}>
                    <Empty isEmpty={data.length === 0} />
                </div>
                {data.map((o, i) => (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}
                        key={i}
                        className="v-list-item v-list-item--alternate v-list--upcoming-sessions"
                    >
                        <div>
                            <p className="v-list-item__title">{o.title}</p>
                            <p style={{ marginBottom: "8px" }}>
                                <b>Location:</b>{" "}
                                <span style={{ color: "#9a9a9c" }}>
                                    {o.location}
                                </span>
                            </p>
                            <p>
                                <b>Time:</b>{" "}
                                <span style={{ color: "#9a9a9c" }}>
                                    {renderDate(o.time)}
                                </span>
                            </p>
                        </div>
                        <div className="v-list--upcoming-sessions__status">
                            <p>Status</p>
                        </div>
                    </div>
                ))}
            </div>
            {titleLink && (
                <div style={{ padding: "0px 45px 25px 45px" }}>
                    <Link text="See all upcoming sessions" url={titleLink} />
                </div>
            )}
        </WidgetBox>
    );
};

export default YourUpcomingSessions;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/your-upcoming-sessions.js